import React, { Fragment, useState } from "react";
import { 
  Box, 
  Container, 
  Grid, 
  Pagination, 
  Stack,
  Typography,
  useTheme,
  useMediaQuery 
} from "@mui/material";
import BlogCard from "../../example/home/Blog/BlogCard";
import PageHeader from "../../example/pages-header/PageHeader";
import useFetchObjects from "../../api/useFetchObjects";
import ErrorPage from "../../components/error/Error";
import NoData from "../../components/no-data/NoData";
import BlogSkeleton from "./loading/BlogSkeleton";
import SEO from "../../components/ceo/CEO";

const Blog = () => {
  const [page, setPage] = useState(1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { data, isLoading, isError, isSuccess, error, refetch } =
    useFetchObjects(["blogs", page], `blogs?page=${page}&page_size=6`);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isLoading) {
    return <BlogSkeleton />;
  }

  if (isError) {
    return <ErrorPage errorMessage={error.message} refetch={refetch} />;
  }

  if (isSuccess && (!data?.results || data.results.length === 0)) {
    return <NoData refetch={refetch} />;
  }

  if (isSuccess) {
    return (
      <Fragment>
        <SEO
          title="Blog - Latest Insights from SHALL"
          description="Discover the latest updates, articles, and news from the SHALL Social and Development Organization."
          url="https://shallafg.org/news/"
          image="https://shallafg.org/media/images/logo.png"
        />
        <PageHeader
          title="Explore Our Latest Insights"
          subtitle="Get the latest updates, articles, and news from our team."
        />
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
            color: "#FFFFFF",
            minHeight: "100vh",
            paddingY: "60px",
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              {data.results.map((blog) => (
                <Grid item xs={12} sm={6} md={4} key={blog.id}>
                  <BlogCard blog={blog} />
                </Grid>
              ))}
            </Grid>

            {/* Updated Pagination Section */}
            {data?.count > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 8,
                  mb: 4,
                }}
              >
                <Pagination
                  count={Math.ceil(data.count / 6)} // Since page_size is 6
                  page={page}
                  onChange={handlePageChange}
                  size={isMobile ? "medium" : "large"}
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#A9C9EA',
                      fontSize: '1rem',
                      '&:hover': {
                        backgroundColor: 'rgba(169, 201, 234, 0.1)',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#A9C9EA',
                        color: '#1A2E55',
                        fontWeight: 600,
                        '&:hover': {
                          backgroundColor: '#8BB5E0',
                        },
                      },
                    },
                    '& .MuiPaginationItem-page': {
                      minWidth: { xs: '32px', md: '40px' },
                      height: { xs: '32px', md: '40px' },
                    },
                    '& .MuiPaginationItem-previousNext': {
                      color: '#A9C9EA',
                      '&:hover': {
                        backgroundColor: 'rgba(169, 201, 234, 0.1)',
                      },
                    },
                  }}
                />
              </Box>
            )}
          </Container>
        </Box>
      </Fragment>
    );
  }
};

export default Blog;
